module.exports = __webpack_public_path__ + "img/logoApplePhone.9142a95c.svg";